
import { Component, Emit, Prop, Vue } from "nuxt-property-decorator";

interface DeliveryOption {
  value: string;
  label: string;
  icon: string;
}

@Component
export default class DeliveryTypeRadio extends Vue {
  @Prop({ required: true }) readonly selectPelletsOption!: string;

  @Emit()
  updatePelletsValue(value: string): string {
    return value;
  }

  options: DeliveryOption[] = [
    {
      value: "loose",
      label: "Lose Ware",
      icon: "delivery",
    },
    {
      value: "pallet",
      label: "Sackware",
      icon: "package",
    },
    {
      value: "bigbag",
      label: "Big Bags",
      icon: "bag",
    },
  ];
}
